import { Route, Routes, Outlet } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import React, { FC, Suspense } from 'react'
// import { MassBalancerMenu } from './MassBalancerMenu'
import { ISSEUMenu } from './ISSEU'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../../../_metronic/helpers'
import { UserManagementWrapper } from '../data-administration/data-admininstration-list/user-management/userManagementList'
import { WasteCollectorPaymentList } from '../data-administration/data-admininstration-list/waste-collector-payment/wasteCollectorPaymentList'
import { MassBalancerWrapper } from './mass-balancer-modules/mass-balancer-report/massBalanceReportList'
import { MBFM } from './mass-balancer-modules/mass-balancer-report/MassBalFm'
import { WCC2 } from '../data-administration/data-admininstration-list/waste-collector-payment/wCC2'

import { IsccOutput } from '../data-administration/data-admininstration-list/collect-orders/isccOutput'
import { IsccPos } from '../data-administration/data-admininstration-list/collect-orders/isccOutputCopy'

import { FeedStockWrapper } from '../settings/settting-modules/sub-category-wrapper/feedStockIscc'
import { IsccProcessingRoutesWrapper } from '../settings/settting-modules/processing-routes/proRoutesIscc'
import { TransportListWrapper } from '../settings/settting-modules/transport/transportList'
import { IsccCollectOrdersWrapper } from '../data-administration/data-admininstration-list/collect-orders/isccCollectOrdersList'
import { IsccWasteCollectorPaymentList } from '../data-administration/data-admininstration-list/waste-collector-payment/IsccwasteCollectorPaymentList'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Feedstock',
    path: '/apps/iscceu',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]


const usersBreadcrumbs2: Array<PageLink> = [
  {
    title: 'Processing',
    path: '/apps/iscceu',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const usersBreadcrumbs3: Array<PageLink> = [
  {
    title: 'Transport',
    path: '/apps/iscceu',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const usersBreadcrumbs4: Array<PageLink> = [
  {
    title: 'Self Declaration',
    path: '/apps/iscceu',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]


const usersBreadcrumbs5: Array<PageLink> = [
  {
    title: 'Input Inventory',
    path: '/apps/iscceu',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const usersBreadcrumbs6: Array<PageLink> = [
  {
    title: 'Output Inventory',
    path: '/apps/iscceu',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
const usersBreadcrumbs7: Array<PageLink> = [
  {
    title: 'POS',
    path: '/apps/iscceu',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ISSEUMenuPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route index element={<ISSEUMenu />} />
        <Route
          path='feed'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs}>Feedstock</PageTitle>
              <FeedStockWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='Iscc-Processing'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs2}>Processing</PageTitle>
              <IsccProcessingRoutesWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='transport'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs3}>Transport</PageTitle>
              <TransportListWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='self-declaration'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs4}>Self Declaration</PageTitle>
              <IsccCollectOrdersWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='sd'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs5}>Input Inventory</PageTitle>
              <IsccWasteCollectorPaymentList />
            </SuspensedView>
          }
        />
        <Route
          path='sd2'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs6}>Output Inventory</PageTitle>
              <IsccOutput />
            </SuspensedView>
          }
        />
        <Route
          path='posIscc'
          element={
            <SuspensedView>
              <PageTitle breadcrumbs={usersBreadcrumbs7}>poS</PageTitle>
              <IsccPos />
            </SuspensedView>
          }
        />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export default ISSEUMenuPage
